import { useState } from "react";
import { useContext } from "react";

const { createContext } = require("react");

export const AdminContext = createContext();

export const useAuth = () => {
    return useContext(AdminContext)
}

export const AuthProvider = (props) => {

    const [authUser, setAuthUser] = useState(null);
    const [isLoggedIn, setIsLoggedIn] = useState(false);

    const value = {
        authUser,
        setAuthUser,
        isLoggedIn,
        setIsLoggedIn
    }

    return (
        <AdminContext.Provider value={value}>
            {props.children}    
        </AdminContext.Provider>
    )
}